import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Header.css';
import headerImage from '../images/header-background.jpg';

const Header = () => {
    const [adminMenuOpen, setAdminMenuOpen] = useState(false);
    const navigate = useNavigate();
    const menuRef = useRef(null);

    // Cierra el menú de admin si se hace clic fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setAdminMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Función para navegar a admin y cerrar el menú
    const handleAdminClick = () => {
        navigate('/admin');
        setAdminMenuOpen(false);
    };

    return (
        <header className="header-container">
            <div className="header-background" style={{ backgroundImage: `url(${headerImage})` }}></div>
            <div className="header-content">

                <h1 className="header-title">Hostal Jallalla</h1>

                <div className="header-bottom-row">
                    <Link to="/" className="logo-container">
                        <img src="/images/logo.png" alt="Logo del Hostal" className="logo" />
                    </Link>

                    <nav className="main-nav">
                        <ul className="nav-links">
                            <li><Link to="/" className="nav-button">Inicio</Link></li>
                            <li><Link to="/nosotros" className="nav-button">Nosotros</Link></li>
                            <li><Link to="/galeria" className="nav-button">Galería</Link></li>
                        </ul>
                    </nav>

                    <div className="admin-area">
                        {/* --- INICIO DEL CAMBIO (VISTA DE ESCRITORIO) --- */}
                        <div className="admin-button-desktop">
                            {/* Se añade el enlace de descarga con el estilo de botón */}
                            <a href="/apk/HostalJallalla.apk" download className="admin-button">
                                Descargar App
                            </a>
                            {/* Se añade un margen a la izquierda para separarlo */}
                            <button className="admin-button" onClick={() => navigate('/admin')} style={{ marginLeft: '8px' }}>
                                Administrador
                            </button>
                        </div>
                        {/* --- FIN DEL CAMBIO --- */}

                        <div className="mobile-admin-menu" ref={menuRef}>
                            <button className="menu-toggle" onClick={() => setAdminMenuOpen(!adminMenuOpen)}>
                                <span className="hamburger-line"></span>
                                <span className="hamburger-line"></span>
                                <span className="hamburger-line"></span>
                            </button>
                            {adminMenuOpen && (
                                // --- INICIO DEL CAMBIO (MENÚ DE HAMBURGUESA) ---
                                <div className="dropdown-menu">
                                    
                                    {/* Se mantiene la estructura original, solo con los botones de acción */}
                                    <a href="/apk/HostalJallalla.apk" download className="admin-button dropdown-button">
                                        Descargar App 😎
                                    </a>
                                    {/* Se añade un margen superior para separarlo en el menú desplegable */}
                                    <button className="admin-button dropdown-button" onClick={handleAdminClick} style={{ marginTop: '10px' }}>
                                        Administrador
                                    </button>
                                </div>
                                // --- FIN DEL CAMBIO ---
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
